import { Outlet, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import Drawer from '@mui/material/Drawer';
import Header from '../general/Header'
import SideMenu from '../general/SideMenu'
import classes from './MainLayout.module.scss'
import { clearAccess, getRemainingTime, isAccessValid } from "../../utils/isAccessValid";

const MainLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const { language } = useSelector(state => state.auth)
    const [showSideBar, setShowSideBar] = useState(false);
    const [planDetails, setPlanDetails] = useState(null);
    const [userData, setUserData] = useState({
        fullName: "Addmix Admin",
    });

    // useEffect(() => {
    //     if (!isAccessValid()) {
    //         navigate('/auth/access-request');
    //     }
    //     if(!window.location.pathname.includes("/auth") && getRemainingTime() <= 0 ) {
    //         console.log("Access expired, redirecting to access request page.", window.location.pathname);
    //         console.log("Remaining time:", getRemainingTime());
    //         clearAccess();
    //         window.location.href = '/auth/access-request';
    //     }
    // }, [navigate]);
    
    if (!isAccessValid()) {
        console.log("Access expired, redirecting to access request page.", window.location.pathname);
        clearAccess();
        navigate('/auth/access-request');
    }

    return (
        <div className={classes.mainLayout} dir={language === "ar" ? "rtl" : "ltr"}>
            <div className={classes.sideMenu}>
                <SideMenu planDetails={planDetails} />
                 <Drawer
                    open={showSideBar}
                    onClose={() => setShowSideBar(false)}
                >
                    <SideMenu setShowSideBar={setShowSideBar} showSideBar={showSideBar} planDetails={planDetails} />
                </Drawer> 
            </div>
            <div className={classes.rightSide}>
                <div className={classes.header}>
                    <Header setShowSideBar={setShowSideBar} userData={userData} />
                </div>
                <div className={classes.main}>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default MainLayout